const HELSINKI_TIME_ZONE = "Europe/Helsinki";

function toDate(value) {
  if (value instanceof Date) {
    return value;
  }

  return new Date(value);
}

export function formatHelsinkiDateTime(value) {
  const date = toDate(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const formattedDate = date.toLocaleDateString("fi-FI", {
    timeZone: HELSINKI_TIME_ZONE,
  });
  const formattedTime = date.toLocaleTimeString("fi-FI", {
    timeZone: HELSINKI_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${formattedDate} kello ${formattedTime}`;
}

export function formatHelsinkiDateTimeLocal(value) {
  const date = toDate(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: HELSINKI_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const part = (type) => parts.find((item) => item.type === type)?.value;

  return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
}
